export const getAvailability = (exhibitionSlug) => {
  return new Promise(async (resolve, reject) => {
    await axios.get('/api/shop/' + exhibitionSlug + '/availability')
      .then(response => {
        resolve(response.data)
      })
      .catch(_error => {
        reject(false)
      })
  })
}

export const getDocuments = (exhibitionSlug) => {
  return new Promise(async (resolve, reject) => {
    await axios.get('/api/shop/' + exhibitionSlug + '/documents')
      .then(response => {
        resolve(response.data)
      })
      .catch(_error => {
        reject(false)
      })
  })
}

export const getExhibitionInformation = (exhibitionSlug) => {
  return new Promise(async (resolve, reject) => {
    await axios.get('/' + exhibitionSlug + '/api')
      .then(response => {
        resolve(response.data)
      })
      .catch(_error => {
        reject(false)
      })
  })
}